import styled from '@emotion/styled';
import { typography } from '@landsbankinn/ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { Seperator } from '../calculators/shared/Seperator';
import { CardWrapper } from './card/CardWrapper';

const Host = styled.div`
  width: 100%;
  background-color: white;

  padding-top: 44px;
  padding-left: 44px;
  padding-right: 15px;
  min-height: 284px;
`;

const Name = styled.p`
  ${typography.h3};
  margin-bottom: 6px;
  visibility: hidden;
`;

const Title = styled.h3`
  ${typography.h3};
  margin-bottom: ${(props) => 15 * props.theme.baseline}px;
  visibility: hidden;
`;

const Text = styled.p`
  visibility: hidden;
  ${typography.body};
`;

const SkeletonContainer = styled.div`
  width: 100%;
  position: relative;
`;

const StyledSkeleton = styled(Skeleton)`
  position: absolute;
  top: 0;
  height: calc(100% - 4px);
`;

function Card() {
  return (
    <Host>
      <SkeletonContainer>
        <Name>Loading</Name>
        <StyledSkeleton />
      </SkeletonContainer>

      <SkeletonContainer>
        <Text>Loading</Text>
        <StyledSkeleton />
      </SkeletonContainer>
      <SkeletonContainer>
        <Text>Loading</Text>
        <StyledSkeleton />
      </SkeletonContainer>
      <Seperator border currentTheme="primary" />
    </Host>
  );
}

export function LoadingCards() {
  return (
    <>
      {/* hidden title to adjust the height of the loader */}
      <Title>Loading</Title>
      <CardWrapper>
        <Card />
        <Card />
        <Card />
      </CardWrapper>
    </>
  );
}
